class NSSCountdownTimer extends HTMLElement {

    constructor() {
        const currentDate = new Date();
        super();

        this.debug = false;

        this.secondConst = 1000;
        this.minuteConst = 60 * this.secondConst;
        this.hourConst = 60 * this.minuteConst;
        this.dayConst = 24 * this.hourConst;

        this.deadlineEod = this.getAttribute('data-count-eod') === 'true';
        this.deadline = this.deadlineEod ? new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999) : Number(this.getAttribute('data-datetime') || 0);
        this.showDays = this.getAttribute('data-show-days') === 'true';
    }

    connectedCallback() {
        if (this.debug) console.log("[NSS][Countdown Timer] Connected.");

        this.initCountdown();
    }

    initCountdown() {
        const countdownInterval = setInterval(() => {
            const currentTime = new Date();
            let timeRemaining = this.deadline - currentTime.getTime();
            if (timeRemaining < 1) {
                clearInterval(countdownInterval);
                this.classList.add('is--expired');
            }
            const days = this.showDays ? Math.floor(timeRemaining / this.dayConst) : 0;
            if (this.showDays) {
                timeRemaining = timeRemaining % this.dayConst;
            }
            const hours = Math.floor(timeRemaining / this.hourConst);
            timeRemaining = timeRemaining % this.hourConst;
            const minutes = Math.floor(timeRemaining / this.minuteConst);
            timeRemaining = timeRemaining % this.minuteConst;
            const seconds = Math.floor(timeRemaining / this.secondConst);
            this.innerHTML = (this.showDays ? days.toString().padStart(2, '0') + 'D ' : '') + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
        }, 1000);
        setTimeout(() => {
            this.classList.add('is--initialized');
        }, 1000);
    }
}

let elementName = `nss-countdown-timer`;
if (typeof customElements.get(elementName) === `undefined`) {
    customElements.define(elementName, NSSCountdownTimer);
} else {
    console.warn(`[NSS] Element '${elementName}' already defined.`);
}